import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import SibilusNavbar from '../c/Navbar';
import Footer from '../c/Footer';
import BigText from '../c/BigText';

const PrivacyPage = () => {
	return (
		<React.Fragment>
			<SibilusNavbar />
			<Container>
				<Row className="py-4">
					<Col xs="12" lg="10" className="promotion_box mx-auto px-3 pb-3 pb-lg-5 px-lg-5 bg-white">
						<div className="privacy_page">
							<BigText k="privacy_policy" replace={[{src: "__COMPANYNAME__", dst: "dit firma"}]}/>
						</div>
					</Col>
				</Row>
			</Container>
			<Footer />
		</React.Fragment>
	);
}

export default PrivacyPage;
